var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvokado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 34,
    viewBox: "0 0 23 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M21.487 21.377c0 6.937-4.81 11.565-10.744 11.565C4.81 32.942 0 28.314 0 21.377c0-3.86 2.485-10.607 4.828-15.831C6.697 1.38 8.112 0 10.743 0c2.662 0 4.1 1.45 5.976 5.683 2.309 5.204 4.768 11.867 4.768 15.694",
    transform: "translate(.743 .32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A7054",
    d: "M16.364 22.196c0 3.104-2.516 5.62-5.62 5.62s-5.62-2.516-5.62-5.62 2.516-5.62 5.62-5.62 5.62 2.516 5.62 5.62",
    transform: "translate(.743 .32)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvokado);
export default __webpack_public_path__ + "static/media/avokado.275f0148f8db6485847df48cbc6dfce6.svg";
export { ForwardRef as ReactComponent };